import { createRoot } from "react-dom/client";
import "./index.css";
import AirflowSection from "./App.jsx";

function initAirflowSection() {
  const container = document.getElementById("airflow-root");
  if (container) {
    const root = createRoot(container);
    root.render(<AirflowSection />);
  } else {
    console.warn("Airflow section container #airflow-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAirflowSection);
} else {
  initAirflowSection();
}
